<template>
<div class="paycenter-wrap">
	<div class="fx-header goback">
		<i class="el-icon-back" @click="goBack"></i><p>支付中心</p>
	</div>
	<div class="paycenter-content">
		<div class="shop-name">
			店铺名称：{{editData.name}}
		</div>
		<div class="radio-box">
			<el-checkbox v-model="paymentMode" :disabled="paymentMode2">商龙支付</el-checkbox>
			<el-tooltip effect="dark" placement="right" popper-class="tip-class">
				<div slot="content">
					商龙支付请前往商龙钱包进行配置，配置好账户后，在极速订卖家-集团设置-商龙云信息中把G号填好点击保存即可。<br>如下拉框中未查询到账户信息或缺失账户信息，请联系商龙钱包团队或服务中心。
				</div>
				<i class="el-icon-warning-outline tip-icon"></i>
			</el-tooltip>
		</div>
		<div class='detail-box1'>
			<div class="input-box" v-if="AuthorityList['04_0001_0002_00']">
				<el-button type='text' @click="getInfo">获取MCID</el-button>
			</div>
			<div class="input-box">
				<span>MCID：</span>
				<el-select :disabled="!AuthorityList['04_0001_0002_00']" class="name-input" size='mini' @change="mcidChange" clearable filterable v-model="mcid">
					<el-option v-for="(item,index) in mcidList" :key='index' :label="item.label" :value='item.mcid'></el-option>
				</el-select>
			</div>
		</div>
		<div class="radio-box">
			<el-checkbox v-model="tenpay" @change="tenpayChange">微企付</el-checkbox>
		</div>
		<div class='detail-box1'>
			<div class="input-box" v-if="AuthorityList['04_0001_0002_00']">
				<el-button type='text' @click="getTenpayInfo">获取微企付账户信息</el-button>
			</div>
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="70px" :label-position="labelPosition">
				<el-form-item label="账号：">
					<el-select :disabled="!AuthorityList['04_0001_0002_00']" class="name-input" size='mini' clearable filterable v-model="tenpayid">
						<el-option v-for="(item,index) in msepayparamlist" :key='index' :label="item.entname + '-' + item.bankcardnumberlast4" :value='item.id'></el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</div>
		<!-- 云资金 -->
		<div v-for="item in shopPays" :key="item.id">
			<div class="radio-box">
				<el-checkbox v-model="item.payflag" :true-label="1" :false-label="0">{{item.payname}}</el-checkbox>
				<div class="refresh-box" @click="refreshClick" style="color: var(--fx-primary-color);cursor: pointer;margin-left: 10px;font-size: 15px;font-weight: normal;">
					<i class="el-icon-refresh refresh-icon"></i>
					获取云资金账户信息
				</div>
				<div v-if="item.showplanflag">
					<span style="margin: 0 20px">是否使用SCM8支付方案</span>
					<el-radio v-model="item.planflag" :label="1" :disabled="!item.payflag">是</el-radio>
					<el-radio v-model="item.planflag" :label="0" :disabled="!item.payflag">否</el-radio>
				</div>
			</div>
			<div class='detail-box1' style="height:50px">
				<el-form :model="ruleForm" ref="ruleForm" label-width="70px" :label-position="labelPosition">
					<el-form-item label="账号：">
						<div>{{cldpaymcid}}</div>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<div class="b2b-setting-container">
			<div class="b2b-setting__header">
				<div style="flex: 1">
					<div class="b2b-setting__header--title">B2b门店助手<i class="el-icon-refresh refresh-icon" @click="getInfo"></i>
						<div class="b2b-setting__header--title-setting">
							<el-tooltip class="item" effect="dark" placement="top">
								<div slot="content">设置为【是】后，客户使用在线支付进行采购订单报货并且选择B2b门店助手支付时,首次支付付款人进行弹认证框<br/>设置为【否】后，客户使用在线支付进行采购订单报货并且选择B2b门店助手支付时,不强制进行认证,但费率默认为千6,谨慎开启该参数!</div>
								<i class="el-icon-question" style="cursor: pointer;color: var(--fx-primary-color);margin-left: 10px;font-size: 16px;"></i>
							</el-tooltip>
							<span style="margin: 0 20px 0 0">采购订单使用B2b门店助手支付时是否强制认证</span>
							<el-radio v-model="b2bForceAuthFlag " :label="1">是</el-radio>
							<el-radio v-model="b2bForceAuthFlag " :label="0">否</el-radio>
						</div>
					</div>
					<div>请前往卖家-><router-link to="storeSetting" style="color: var(--fx-primary-color)">店铺设置</router-link>->授权管理中填写APPID用于拉取B2b门店助手账户</div>
				</div>
				<el-button size='small' type='primary' class="link" @click="$fxGoBlank('https://mp.weixin.qq.com')">前往微信公众平台</el-button>
			</div>
			<div class="b2b-setting__main">
				<div class="radio-box">
					<el-checkbox v-model="b2bWechatPay" @change="b2bWechatPayChange">B2b门店助手-微信支付</el-checkbox>
				</div>
				<div class='detail-box1' style="height:50px">
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="70px" :label-position="labelPosition">
						<el-form-item label="账号：">
							<el-select :disabled="!AuthorityList['04_0001_0002_00']" class="name-input" size='mini' clearable filterable v-model="wechatMchid">
								<el-option v-for="(item,index) in wechatMchidList" :key='index' :label="item.mchid + '-' + item.name" :value='item.mchid'></el-option>
							</el-select>
						</el-form-item>
					</el-form>
				</div>
				<div class="radio-box">
					<el-checkbox v-model="b2bBankPay" @change="b2bBankPayChange">B2b门店助手-银行转账</el-checkbox>
					<div>
						<span style="margin: 0 20px">是否分账</span>
						<el-radio v-model="bankMchidProfitSharing" :label="1">是</el-radio>
						<el-radio v-model="bankMchidProfitSharing" :label="0">否</el-radio>
					</div>
				</div>
				<div class='detail-box1' style="height:50px">
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="70px" :label-position="labelPosition">
						<el-form-item label="账号：">
							<el-select :disabled="!AuthorityList['04_0001_0002_00']" class="name-input" size='mini' clearable filterable v-model="bankMchid">
								<el-option v-for="(item,index) in bankMchidList" :key='index' :label="item.mchid + '-' + item.name" :value='item.mchid'></el-option>
							</el-select>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</div>
	</div>
	<div class="footer" v-if="AuthorityList['04_0001_0002_00']">
		<el-button size='small' class="fx-big-btn" @click="goBack">取消</el-button>
		<el-button size='small' type='primary' class="fx-big-btn" @click="save">保存</el-button>
	</div>
</div>

</template>

<script>
export default {
	name: 'payCenyerEdit',

	data () {
		return {
			gcid: '',
			editData: {},
			groupcode: '',
			mcid: '',
			mcidList: [],
			AuthorityList: {
				'04_0001_0001_00': false,
				'04_0001_0002_00': false
			},
			sStoreCode: '',
			paymentMode: false,
			paymentMode2: false,
			tenpay: false,
			tenpayid: '',
			ruleForm: {
				cmbuserid: '',
				cmbmerid: '',
				cmbappid: '',
				cmbappsecret: '',
				bankcardnumberlast4: ''
			},
			ruleForm2: {
				cmbcmerid: '',
				cmbctax: '',
				cmbcsecmerid: '',
				cmbcsectax: '',
				cmbcpassword: ''
			},
			labelPosition: 'left',
			rules: {
				cmbuserid: [
					{ required: true, message: '不能为空', trigger: 'blur' },
					{ min: 0, max: 100, message: '不能超过100个文字', trigger: 'blur' }
				],
				cmbmerid: [
					{ required: true, message: '不能为空', trigger: 'blur' },
					{ min: 0, max: 100, message: '不能超过100个文字', trigger: 'blur' }
				],
				cmbappid: [
					{ required: true, message: '不能为空', trigger: 'blur' },
					{ min: 0, max: 100, message: '不能超过100个文字', trigger: 'blur' }
				],
				cmbappsecret: [
					{ required: true, message: '不能为空', trigger: 'blur' },
					{ min: 0, max: 100, message: '不能超过100个文字', trigger: 'blur' }
				]
			},
			uploadType: '',
			pfxfileUrl: '',
			cerfileUrl: '',
			msepayparamlist: [],
			fxDataVerification: this.$fxUtils.fxDataVerification(),
			cldpayonlineflag: 0,
			cldpayremittanceflag: 0,
			cldpaymcid: '',
			cldpayonlineplanflag: 0,
			cldpayremittanceplanflag: 0,
			shopPays: [],
			b2bPays: [],
			b2bWechatPay: false,
			b2bBankPay: false,
			bankMchid: '',
			wechatMchid: '',
			bankMchidList: [],
			wechatMchidList: [],
			bankMchidProfitSharing: 0,
			b2bForceAuthFlag: 0
		}
	},
	created () {
		this.$fxEventBus.$emit('setMenu', '8-1')
		this.editData = JSON.parse(this.$route.query.editData)
		this.getAuthority('04_0001_0000_00')
		this.getInfo()
	},
	methods: {
		tenpayChange () {
			if (this.msepayparamlist.length === 0) {
				this.$message.error('请先开通微企付')
				this.tenpay = false
			}
		},
		b2bWechatPayChange () {
			if (this.wechatMchidList.length === 0) {
				this.$message.error('请先开通B2b门店助手')
				this.b2bWechatPay = false
			}
		},
		b2bBankPayChange () {
			if (this.bankMchidList.length === 0) {
				this.$message.error('请先开通B2b门店助手')
				this.b2bBankPay = false
			}
		},
		cldpayonlineflagChange (val) {
			if (!val) {
				this.cldpayonlineplanflag = 0
			}
		},
		cldpayremittanceflagChange (val) {
			if (!val) {
				this.cldpayremittanceplanflag = 0
			}
		},
		goBack () {
			this.$router.push('/main/payCenter')
		},
		getAuthority (id) {
			let params = {
				pId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		refreshClick () {
			let params = {
				shopId: this.editData.id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/payCenter/cldPayRefresh`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		mcidChange () {
			if (this.mcid === '' || this.mcid === null) {
				this.gcid = ''
				this.mcid = ''
			} else {
				this.selectGcid()
			}
		},
		selectGcid () {
			let list = this.mcidList
			for (let i = 0; i < list.length; i++) {
				if (this.mcid === list[i].mcid) {
					this.gcid = list[i].gcid
				}
			}
		},
		getTenpayInfo () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/payCenter/tenpay/get`
			}).then(this.getInfo)
		},
		getInfo () {
			let params = {
				shopId: this.editData.id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/payCenter/detail`,
				data: params
			}).then(res => {
				if (res.result) {
					this.groupcode = res.data.shop.groupcode
					this.ruleForm.cmbappid = res.data.shop.cmbappid
					this.ruleForm.cmbappsecret = res.data.shop.cmbappsecret
					this.ruleForm.cmbmerid = res.data.shop.cmbmerid
					this.ruleForm.cmbuserid = res.data.shop.cmbuserid
					this.ruleForm2.cmbcmerid = res.data.shop.cmbcmerid
					this.ruleForm2.cmbcsecmerid = res.data.shop.cmbcsecmerid
					this.ruleForm2.cmbctax = res.data.shop.cmbctax
					this.ruleForm2.cmbcsectax = res.data.shop.cmbcsectax
					this.ruleForm2.cmbcpassword = res.data.shop.cmbcpassword
					this.paymentMode = res.data.shop.paychannel === 1
					this.paymentMode2 = res.data.shop.paychannel === 2
					this.tenpay = res.data.shop.tenpay
					this.pfxfileUrl = res.data.pfxfile ? 'https://' + location.host + res.data.pfxfile : ''
					this.cerfileUrl = res.data.cerfile ? 'https://' + location.host + res.data.cerfile : ''
					if (res.data.shop.mcid === '0') {
						this.mcid = ''
					} else {
						this.mcid = res.data.shop.mcid
					}
					this.msepayparamlist = res.data.msepayparamlist
					this.tenpayid = res.data.shop.tenpayid === 0 ? '' : res.data.shop.tenpayid
					this.cldpayonlineflag = res.data.shop.cldpayonlineflag === 1
					this.cldpayremittanceflag = res.data.shop.cldpayremittanceflag === 1
					this.cldpayonlineplanflag = res.data.shop.cldpayonlineplanflag
					this.cldpayremittanceplanflag = res.data.shop.cldpayremittanceplanflag
					this.cldpaymcid = res.data.shop.cldpaymcid
					// TODO 过滤拉卡拉全渠道-收银台
					this.shopPays = res.data.cldpayPays.filter(item => item.paymode !== 15)
					this.b2bPays = res.data.b2bPays
					this.b2bPays.forEach(item => {
						if (item.paymode === 11 && item.payflag) {
							this.b2bWechatPay = true
						}
						if (item.paymode === 12 && item.payflag) {
							this.b2bBankPay = true
						}
					})
					this.bankMchidList = res.data.bankMchidList || []
					this.wechatMchidList = res.data.wechatMchidList || []
					this.wechatMchid = res.data.shopScmpayAccount ? res.data.shopScmpayAccount.wechatMchid : ''
					this.bankMchid = res.data.shopScmpayAccount ? res.data.shopScmpayAccount.bankMchid : ''
					this.bankMchidProfitSharing = res.data.shopScmpayAccount ? res.data.shopScmpayAccount.bankMchidProfitSharing : 0
					this.b2bForceAuthFlag = res.data.shopScmpayAccount ? res.data.shopScmpayAccount.b2bForceAuthFlag : 0
					this.getMcid()
					let originData = {
						paymentMode: this.paymentMode,
						tenpay: this.tenpay,
						mcid: this.mcid,
						tenpayid: this.tenpayid,
						cldpayonlineflag: this.cldpayonlineflag,
						cldpayremittanceflag: this.cldpayremittanceflag,
						cldpayonlineplanflag: this.cldpayonlineplanflag,
						cldpayremittanceplanflag: this.cldpayremittanceplanflag,
						shopPays: this.shopPays,
						b2bPays: this.b2bPays,
						b2bWechatPay: this.b2bWechatPay,
						wechatMchid: this.wechatMchid,
						b2bBankPay: this.b2bBankPay,
						bankMchid: this.bankMchid,
						bankMchidProfitSharing: this.bankMchidProfitSharing,
						b2bForceAuthFlag: this.b2bForceAuthFlag
					}
					this.fxDataVerification.resetData(originData)
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		getTenpayId () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlSV}/shop/tenpay/productapplication/status`
			}).then(res => {
				if (res.result) {
					this.tenpayid = res.data.id
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		getMcid () {
			if (this.groupcode === '') {
				if (this.mcid !== '') {
					this.$alert('当前MCID已不存在，请重新绑定MCID，否则将影响支付', '提示', {
						confirmButtonText: '确定',
						type: 'error'
					})
				}
				return false
			}
			let params = {
				groupCode: this.groupcode
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/payCenter/mcid/get`,
				data: params
			}).then(res => {
				if (res.result) {
					if (res.data === null) {
						if (this.mcid !== '') {
							this.$alert('当前MCID已不存在，请重新绑定MCID，否则将影响支付', '提示', {
								confirmButtonText: '确定'
							})
						}
					} else {
						this.mcidList = JSON.parse(res.data)
						this.sStoreCode = this.mcidList[0].sStoreCode
						if (this.mcid !== '') {
							let flag = false
							for (let i = 0; i < this.mcidList.length; i++) {
								if (this.mcid === this.mcidList[i].mcid) {
									flag = true
									this.gcid = this.mcidList[i].gcid
								}
							}
							if (flag === false) {
								this.$alert('当前MCID已不存在，请重新绑定MCID，否则将影响支付3', '提示', {
									confirmButtonText: '确定'
								})
							}
						}
						for (let i = 0; i < this.mcidList.length; i++) {
							if (this.mcidList[i].storeName) {
								this.mcidList[i].label = this.mcidList[i].storeName + '-' + this.mcidList[i].mcid
							} else {
								this.mcidList[i].label = this.mcidList[i].mcid
							}
						}
					}
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		save () {
			if (this.paymentMod2) {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.saveSubmit()
					} else {
						return false
					}
				})
			} else {
				this.saveSubmit()
			}
			// else if (paymentMode === 3) {
			// 	this.$refs['ruleForm2'].validate((valid) => {
			// 		if (valid) {
			// 			if (!this.cerfileUrl || !this.pfxfileUrl) {
			// 				this.$message.error(`请上传附件！`)
			// 				return false
			// 			}
			// 			this.saveSubmit()
			// 		} else {
			// 			return false
			// 		}
			// 	})
			// }
		},
		saveSubmit () {
			let logger = this.createLoggerParams()
			let mode = this.paymentMode ? 1 : this.paymentMode2 ? 2 : 0
			const shopPays = [...this.shopPays, ...this.b2bPays.map(item => {
				if (item.paymode === 11) {
					item.payflag = this.b2bWechatPay ? 1 : 0
				}
				if (item.paymode === 12) {
					item.payflag = this.b2bBankPay ? 1 : 0
				}
				return item
			})]
			let params = {
				mcid: this.mcid,
				gcid: this.gcid,
				sStoreCode: this.sStoreCode,
				cmbmerid: this.ruleForm.cmbmerid,
				cmbuserid: this.ruleForm.cmbuserid,
				cmbappid: this.ruleForm.cmbappid,
				cmbappsecret: this.ruleForm.cmbappsecret,
				paychannel: mode,
				groupCode: this.groupcode,
				shopId: this.editData.id,
				cmbcmerid: this.ruleForm2.cmbcmerid,
				cmbcsecmerid: this.ruleForm2.cmbcsecmerid,
				cmbctax: this.ruleForm2.cmbctax,
				cmbcsectax: this.ruleForm2.cmbcsectax,
				cmbcpassword: this.ruleForm2.cmbcpassword,
				tenpay: this.tenpay,
				tenpayId: this.tenpayid,
				cldpayonlineflag: this.cldpayonlineflag ? 1 : 0,
				cldpayremittanceflag: this.cldpayremittanceflag ? 1 : 0,
				cldpayonlineplanflag: this.cldpayonlineplanflag,
				cldpayremittanceplanflag: this.cldpayremittanceplanflag,
				shopPays,
				logMessage: {
					message: logger.msg,
					referer: logger.url
				}
			}
			console.log(this.wechatMchidList.length, this.bankMchidList.length)
			if (this.wechatMchidList.length || this.bankMchidList.length) {
				Object.assign(params, {
					wechatb2bInfo: {
						wechatMchid: this.wechatMchid,
						bankMchid: this.bankMchid,
						bankMchidProfitSharing: this.bankMchidProfitSharing,
						b2bForceAuthFlag: this.b2bForceAuthFlag
					}
				})
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/payCenter/shop/save`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功')
					this.getInfo()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		createLoggerParams () {
			const originData = this.fxDataVerification.getOriginData()
			// console.log(this.paymentMode, this.tenpay, this.mcid, this.tenpayid)
			let shopMsg = `店铺：${this.editData.name};`
			let originMode = []
			let newMode = []
			let originPlan = []
			let newPlan = []
			if (originData.paymentMode) {
				originMode.push('商龙支付')
			}
			if (originData.tenpay) {
				originMode.push('微企付')
			}
			originData.shopPays.forEach(item => {
				if (item.payflag === 1) {
					originMode.push(item.payname)
				}
				originPlan.push(item.planflag === 1 ? '是' : '否')
			})
			if (originData.b2bWechatPay) {
				originMode.push('B2b门店助手-微信支付')
			}
			if (originData.b2bBankPay) {
				originMode.push('B2b门店助手-银行转账')
			}
			originMode = originMode.length === 0 ? '空' : originMode.join('、')
			if (this.paymentMode) {
				newMode.push('商龙支付')
			}
			if (this.tenpay) {
				newMode.push('微企付')
			}
			this.shopPays.forEach(item => {
				if (item.payflag === 1) {
					newMode.push(item.payname)
				}
				newPlan.push(item.planflag === 1 ? '是' : '否')
			})
			if (this.b2bWechatPay) {
				newMode.push('B2b门店助手-微信支付')
			}
			if (this.b2bBankPay) {
				newMode.push('B2b门店助手-银行转账')
			}
			newMode = newMode.length === 0 ? '空' : newMode.join('、')
			let modeMsg = `支付方式由'${originMode}'修改为'${newMode}';`
			let planMsg = ''
			newPlan.forEach((item, index) => {
				if (item !== originPlan[index]) {
					planMsg += `${this.shopPays[index].payname}是否使用SCM8支付方案由${originPlan[index]}修改为${item}；`
				}
			})
			let originMcid = '空'
			let newMcid = '空'
			this.mcidList.forEach(item => {
				if (originData.mcid === item.mcid) {
					originMcid = item.label
				}
				if (this.mcid === item.mcid) {
					newMcid = item.label
				}
			})
			let mcidMsg = originMcid === newMcid ? '' : `MCID由'${originMcid}'修改为'${newMcid}';`
			let originTenpayId = '空'
			let newTenpayId = '空'
			this.msepayparamlist.forEach(item => {
				if (originData.tenpayid === item.id) {
					originTenpayId = item.entname + '-' + item.bankcardnumberlast4
				}
				if (this.tenpayid === item.id) {
					newTenpayId = item.entname + '-' + item.bankcardnumberlast4
				}
			})
			let originWechatId = '空'
			let newWechatId = '空'
			this.bankMchidList.forEach(item => {
				if (originData.wechatMchid === item.mchid) {
					originWechatId = item.mchid + '-' + item.name
				}
				if (this.wechatMchid === item.mchid) {
					newWechatId = item.mchid + '-' + item.name
				}
			})
			let originBankId = '空'
			let newBankId = '空'
			this.bankMchidList.forEach(item => {
				if (originData.bankMchid === item.mchid) {
					originBankId = item.mchid + '-' + item.name
				}
				if (this.bankMchid === item.mchid) {
					newBankId = item.mchid + '-' + item.name
				}
			})
			let tenpayIdMsg = originTenpayId === newTenpayId ? '' : `微企付账号由'${originTenpayId}'修改为'${newTenpayId}';`
			let wechatIdMsg = originWechatId === newWechatId ? '' : `B2b门店助手-微信支付账号由'${originWechatId}'修改为'${newWechatId}';`
			let bankIdMsg = originBankId === newBankId ? '' : `B2b门店助手-银行转账账号由'${originBankId}'修改为'${newBankId};`
			let bankShareMsg = originData.bankMchidProfitSharing === this.bankMchidProfitSharing ? '' : `B2b门店助手-银行转账是否分账由'${originData.bankMchidProfitSharing ? '是' : '否'}'改为'${this.bankMchidProfitSharing ? '是' : '否'}';`
			let b2bForceAuthMsg = originData.b2bForceAuthFlag === this.b2bForceAuthFlag ? '' : `采购订单使用B2b门店助手支付时是否强制认证由'${originData.b2bForceAuthFlag ? '是' : '否'}'改为'${this.b2bForceAuthFlag ? '是' : '否'}';`
			let msg = shopMsg + modeMsg + mcidMsg + tenpayIdMsg + planMsg + wechatIdMsg + bankIdMsg + bankShareMsg + b2bForceAuthMsg
			let url = window.location.href.split('?')[0]
			url = url.replace(window.location.origin, '').substring(1)
			return {
				msg: msg,
				url: url
			}
		},
		openUploadHandler (type) {
			this.uploadType = type
			this.$refs.file.dispatchEvent(new MouseEvent('click'))
		},
		getFile (e) {
			if (e.target.files[0].name.indexOf(this.uploadType) === -1) {
				this.$message.error(`只能上传文件后缀为${this.uploadType}的文件`)
				return false
			}
			this.uploadHandle()
			this.$refs.file.value = ''
		},
		uploadHandle () {
			return new Promise((resolve, reject) => {
				var formData = new FormData()
				formData.append('file', this.$refs.file.files[0])
				formData.append('shopId', this.editData.id)
				this.$store.dispatch('requestFilePost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/payCenter/file/upload`,
					data: formData
				}).then(res => {
					if (res.result) {
						this.$message.success('导入成功！')
						this.getInfo()
					} else {
						this.$message.error(res.msg)
					}
				})
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.paycenter-wrap {
	display: flex;
	flex-direction: column
	.paycenter-content {
		flex: 1;
		overflow-y: auto
	}
}
span{
	margin-top :10px
}
.tip-icon {
	cursor: pointer
	font-size: 25px
	color: red
	margin-left: 10px
}
.goback{
	span {
		float left
		display inline-block
		line-height 55px
		padding-right 20px
		i {
			border-radius 50%
			border 1px solid #2c3e50
			cursor pointer
		}
	}
	.el-icon-back {
		border-radius: 50%;
    cursor: pointer;
    background: #9da6af;
    padding: 3px;
		float: left;
		margin: 28px 20px 0 10px;
	}
	.el-icon-back:before {
		content: "\E6EA";
    color: #fff;
    font-weight: bold;
	}
}
.radio-box{
	display: flex;
	align-items: center;
	text-align: left;
	padding: 26px 20px 20px 20px;
}
.shop-name {
	// text-align: left;
	font-weight: bold;
	margin: 20px 0 0 20px;
	font-size: 16px
	display: flex
	align-items: center;
	.refresh-box {
		color: var(--fx-primary-color);
		cursor: pointer;
		margin-left: 10px;
		font-size: 15px;
		font-weight: normal;
		.refresh-icon {
			margin-left: 5px;
			color: var(--fx-primary-color);
		}
	}
}
.detail-box1{
	margin-left: 45px
	padding 10px 20px 10px 20px
	display: flex;
	text-align:left ;
	flex-direction: column
	position: relative;
	width: 370px;
	height: 85px;
	border: 1px solid var(--fx-primary-color);
	border-radius: 6px;
  .input-box{
		font-size :15px
		text-align :left
		width :100%;
		margin-bottom:18px
		.name-input {
			width: 200px;
			margin-right: 10px;
		}
        .radio-input{
            width: 400px;
        }
		.select-box{
			width:180px;
			margin-right:10px;
		}
	}
}
.detail-box2{
	width: 370px;
	height: 210px;
	padding 10px 20px 10px 20px
	margin-left: 45px;
	border: 1px solid var(--fx-primary-color);
	border-radius: 6px;
	position relative
	.el-form-item {
		margin-bottom: 10px
	}
}
.detail-box3{
	width: 730px;
	text-align: left;
	line-height: 45px;
	padding: 10px 20px 10px 20px;
	margin-left: 45px;
	border: 1px solid var(--fx-primary-color);
	border-radius: 6px;
	position: relative;
	.el-form-item {
		margin-bottom: 10px
	}
}
.detail-box1::before{  /*这里的伪元素用单冒号和双冒号都一样*/
	content: '';
	display: block;
	position: absolute;
	top: -13px;
	left: 20px;
	border-left: 8px solid transparent;
	border-right: 8px solid transparent;
	border-bottom: 13px solid var(--fx-primary-color);
}
.detail-box2::before{  /*这里的伪元素用单冒号和双冒号都一样*/
	content: '';
	display: block;
	position: absolute;
	top: -13px;
	left: 20px;
	border-left: 8px solid transparent;
	border-right: 8px solid transparent;
	border-bottom: 13px solid var(--fx-primary-color);
}
.detail-box3::before{  /*这里的伪元素用单冒号和双冒号都一样*/
	content: '';
	display: block;
	position: absolute;
	top: -13px;
	left: 227px;
	border-left: 8px solid transparent;
	border-right: 8px solid transparent;
	border-bottom: 13px solid var(--fx-primary-color);
}

/*第二个三角形*/
.detail-box1::after{
	content: '';
	display: block;
	position: absolute;
	top: -12px;
	left: 21px;
	border-left: 7px solid transparent;
	border-right: 7px solid transparent;
	border-bottom: 12px solid #fff;
}
.detail-box2::after{
	content: '';
	display: block;
	position: absolute;
	top: -12px;
	left: 21px;
	border-left: 7px solid transparent;
	border-right: 7px solid transparent;
	border-bottom: 12px solid #fff;
}
.detail-box3::after{
	content: '';
	display: block;
	position: absolute;
	top: -12px;
	left: 228px;
	border-left: 7px solid transparent;
	border-right: 7px solid transparent;
	border-bottom: 12px solid #fff;
}
.el-button--text{
    padding 0px
}
.footer{
	margin: 38px 0 10px 36px
	text-align: left;
	height: 40px
}
.b2b-setting {
	&-container {
		width 800px
		text-align left
		margin-top 20px
		padding 26px 20px 20px 20px
		border 1px solid #EDEFFC
		border-radius 5px
		.radio-box {
			padding-left 0
			padding-right 0
		}
	}
	&__header {
		display flex
		&--title {
			font-size 16px
			padding-bottom 5px
			cursor pointer
			font-weight bold
			display: flex
			align-items: center
			.refresh-icon {
				color var(--fx-primary-color)
			}
			&-setting {
				display: flex
				align-items: center
				font-weight normal
				font-size 14px
			}
		}
		.link {
			height 36px
		}
	}
}
</style>
